module.exports = __webpack_public_path__ + "img/iconArrowNavy.0c6faf2a.svg";